import { ENV_PROD, ENV_TEST } from './types'
export const ENV = ENV_TEST
//export const ENV = ENV_PROD
//const bsUrl = "https://qcm.zydsp.net"
const bsUrl = ENV === ENV_PROD ? 'https://mobile.zydsp.net' : 'https://qcm.zydsp.net'

const base = {
	// 跳转基础路径
	hostUrl: '',
	baseUrl: bsUrl,
	baseImgUrl: `${bsUrl}/static/images`,
	version: '2.0.2', // 当前版本号
}

// #ifdef H5
if (import.meta.env.PROD) {
	//PROD
	const url = new URL(window.location.href)
	const host = url.origin
	// const curWwwPath = window.document.location.href;
	// const pathname = window.document.location.pathname;
	// const pos = curWwwPath.indexOf(pathname);
	// const host = curWwwPath.substring(0, pos);
	if (host) {
		base.hostUrl = host
		base.baseUrl = host
		base.baseImgUrl = `${host}/static/images`
	}
}
// #endif
export default base